// extracted by mini-css-extract-plugin
export default {"exitbutton":"Bookinginfo_exitbutton__IiJ6e","loadingIndicator":"Bookinginfo_loadingIndicator__4FgnN","updateBookingButton":"Bookinginfo_updateBookingButton__hHHkG"};